import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv";
import React from "react";
import { IIconProps } from "./Icon/Interfaces";

const PersonalizeIcon = ({
  width = 21,
  height = 22,
  strokeColor = "var(--gray)",
}: IIconProps) => {
  return (
    <HyperDiv width={width} height={height} centeredY>
      <svg
        height="100%"
        width="100%"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.801 0C15.567 0 14.424 0.616 13.745 1.649C12.848 3.019 12.891 4.91 12.377 6.093C11.636 7.801 8.504 6.436 6.845 5.569C3.936 11.216 1.82 13.78 0 16.017C6.579 20.335 1.823 17.21 12.19 24C14.265 20.009 16.524 16.633 19.015 13.54C17.476 12.299 14.996 9.994 16.401 8.595C17.401 7.595 18.946 7.017 19.843 5.645C21.432 3.219 19.669 0 16.801 0V0ZM11.453 21.138L10.252 20.375C10.252 19.719 10.409 19.077 10.674 18.501C10.065 18.703 9.6 18.983 9.056 19.544L5.701 17.313C6.232 16.61 6.635 15.763 6.56 14.625C6.078 15.449 5.039 16.246 4.229 16.37L2.927 15.555C4.063 14.088 5.168 12.469 6.184 10.827L14.483 16.289C13.384 17.903 12.286 19.652 11.453 21.138V21.138ZM18.177 4.554C17.72 5.254 15.732 6.448 14.993 7.186C14.312 7.866 13.979 8.747 14.032 9.734C14.103 11.088 14.884 12.515 16.25 13.819C16.049 14.084 15.842 14.362 15.632 14.652L7.204 9.104L7.708 8.221C8.773 8.666 9.808 8.899 10.74 8.899C12.386 8.899 13.648 8.166 14.204 6.887C14.663 5.829 14.955 3.439 15.41 2.742C16.616 0.909 19.374 2.725 18.177 4.554V4.554ZM17.533 4.13C17.268 4.54 16.72 4.653 16.313 4.387C15.904 4.12 15.791 3.573 16.058 3.164C16.325 2.755 16.871 2.64 17.28 2.907C17.688 3.173 17.801 3.724 17.533 4.13V4.13Z"
          fill={strokeColor}
        />
      </svg>
    </HyperDiv>
  );
};

export default PersonalizeIcon;
